<template>
  <footer class="site-footer">
    <!-- Sponsors Section -->
    <section class="sponsors-section">
      <div class="container">
        <h2 class="section-title">
          Empresas, Instituciones y Sponsors que nos han acompañado
        </h2>

        <!-- Tier 1: Main Sponsors (largest) -->
        <div class="sponsors-tier sponsors-tier-1">
          <div class="sponsor-item">
            <a href="https://share.google/ui2hZCY9H1SZfvQWd" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(1)">
              <img src="/images/sponsors/Panaderia_Parada_11.png" alt="Panaderia Parada 11" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.orvent.com.uy/eshop/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(2)">
              <img src="/images/sponsors/Montibel.png" alt="Orvent" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://lacisplatina.com/actividades" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(3)">
              <img src="/images/sponsors/La_Cisplatina_Balnco.png" alt="La Cisplatina" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/armeniacocinatipica/?hl=es" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(4)">
              <img src="/images/sponsors/Logo_Armenia.jpeg" alt="Armenia" class="sponsor-logo">
            </a>
          </div>
        </div>

        <!-- Tier 2: Commercial Sponsors (medium) -->
        <div class="sponsors-tier sponsors-tier-2">
          <div class="sponsor-item">
            <a href="https://delsol.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(5)">
              <img src="/images/sponsors/DEl_sol.jpeg" alt="Del Sol" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/papeleria.rayuela/?hl=es" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(6)">
              <img src="/images/sponsors/PAPELERIA_RAYUELA1.png" alt="Papeleria Rayuela" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://gervaso.com/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(7)">
              <img src="/images/sponsors/Gervaso.png" alt="Gervaso" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://metropolitano.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(8)">
              <img src="/images/sponsors/Metropolitano.png" alt="Metropolitano" class="sponsor-logo">
            </a>
          </div>
        </div>

        <!-- Tier 3: Institutional Sponsors (smaller) -->
        <div class="sponsors-tier sponsors-tier-3">
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(9)">
              <img src="/images/sponsors/Ministerio_Educacion_Cultura.jpeg" alt="Ministerio de Educación y Cultura" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/cultura" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(10)">
              <img src="/images/sponsors/Direccion_Nacional_Cultura.jpg" alt="Dirección Nacional de Cultura" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/cultura/inae" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(11)">
              <img src="/images/sponsors/Instituto_Nacional_ de_Artes_Escenicas.jpg" alt="Instituto Nacional de Artes Escénicas" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.ute.com.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(12)">
              <img src="/images/sponsors/UTE.jpg" alt="UTE" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/municipiociudaddelacosta/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(13)">
              <img src="/images/sponsors/Municipio.jpg" alt="Municipio Ciudad de la Costa" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.imcanelones.gub.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(14)">
              <img src="/images/sponsors/Gobierno_Canelones.jpg" alt="Gobierno de Canelones" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-ambiente/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(15)">
              <img src="/images/sponsors/Dinama.jpg" alt="Dinama" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://uruguaynatural.com/es/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(16)">
              <img src="/images/sponsors/Ministerio_turismo.png" alt="Uruguay Natural" class="sponsor-logo">
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        <!-- Social icons -->
        <div class="footer-social">
          <a href="https://www.instagram.com/grupobabiloniauy/" target="_blank" rel="noopener" aria-label="Instagram" class="social-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/grupobabiloniauy" target="_blank" rel="noopener" aria-label="Facebook" class="social-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
        </div>

        <!-- Contact -->
        <div class="footer-contact">
          <a href="mailto:info@grupobabilonia.com.uy" class="footer-email">
            info@grupobabilonia.com.uy
          </a>
        </div>

        <!-- T&C -->
        <div class="footer-legal">
          <a href="/Terminos_Condiciones_Grupo_Babilonia.pdf" target="_blank" rel="noopener" class="footer-tc">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { trackSponsorClick } from '@/utils/analytics.js'

export default {
  name: 'SiteFooter',
  methods: {
    trackClick(sponsorId) {
      trackSponsorClick(sponsorId, this.$route.fullPath)
    }
  }
}
</script>

<style scoped>
/* ===== Sponsors Section ===== */
.sponsors-section {
  background: #000;
  padding: 60px 0 80px;
}

.sponsors-section .section-title {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0.1em;
  margin-bottom: 50px;
  color: #ccc;
  text-transform: uppercase;
}

/* Common tier styles */
.sponsors-tier {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto 40px;
}

.sponsors-tier:last-child {
  margin-bottom: 0;
}

.sponsor-item {
  flex: 0 0 auto;
}

.sponsor-link {
  display: inline-block;
  line-height: 0;
}

/* Tier 1: Main Sponsors - Large */
.sponsors-tier-1 .sponsor-logo {
  width: 200px;
  height: 100px;
}

/* Tier 2: Commercial Sponsors - Medium */
.sponsors-tier-2 .sponsor-logo {
  width: 140px;
  height: 70px;
}

/* Tier 3: Institutional Sponsors - Small */
.sponsors-tier-3 .sponsor-logo {
  width: 90px;
  height: 45px;
}

.sponsors-tier-3 {
  gap: 20px;
}

/* Actual logo styling - FULL COLOR with hover effects */
.sponsor-logo {
  object-fit: contain;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.sponsor-logo:hover {
  transform: scale(1.2);
  filter: brightness(1.15);
  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.25);
}

/* ===== Footer Bottom Bar ===== */
.footer-bottom {
  background: #000;
  border-top: 1px solid #222;
  padding: 18px 24px;
}

.footer-bottom-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}

/* Social */
.footer-social {
  display: flex;
  align-items: center;
  gap: 16px;
}

.social-link {
  color: #666;
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}

.social-link:hover {
  color: #fff;
}

/* Contact */
.footer-email {
  color: #666;
  font-size: 13px;
  letter-spacing: 0.03em;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-email:hover {
  color: #fff;
}

/* T&C */
.footer-tc {
  color: #666;
  font-size: 13px;
  letter-spacing: 0.03em;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-tc:hover {
  color: #fff;
}

/* ===== Mobile Sponsors ===== */
@media (max-width: 992px) {
  .sponsors-section {
    padding: 40px 20px 60px;
  }

  .sponsors-section .section-title {
    font-size: 18px;
    letter-spacing: 0.05em;
    margin-bottom: 30px;
  }

  .sponsors-tier {
    gap: 20px;
    margin-bottom: 30px;
  }

  /* Tier 1: Main Sponsors - Large */
  .sponsors-tier-1 .sponsor-logo {
    width: 160px;
    height: 80px;
  }

  /* Tier 2: Commercial Sponsors - Medium */
  .sponsors-tier-2 .sponsor-logo {
    width: 110px;
    height: 55px;
  }

  /* Tier 3: Institutional Sponsors - Small */
  .sponsors-tier-3 .sponsor-logo {
    width: 70px;
    height: 35px;
  }

  .sponsors-tier-3 {
    gap: 15px;
  }
}

@media (max-width: 576px) {
  .sponsors-tier-1 .sponsor-logo {
    width: 130px;
    height: 65px;
  }

  .sponsors-tier-2 .sponsor-logo {
    width: 90px;
    height: 45px;
  }

  .sponsors-tier-3 .sponsor-logo {
    width: 60px;
    height: 30px;
  }

  .footer-bottom-inner {
    gap: 20px;
  }

  .footer-email,
  .footer-tc {
    font-size: 12px;
  }
}
</style>